import {
  call, put, takeEvery, take,
} from 'redux-saga/effects';
// import jwt from 'jsonwebtoken';

import { AppActionTypes, MeActionTypes } from '../actions/types';
import { AppActionCreators, MeActionCreators } from '../actions/creators';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { toast } from '../../utilities';

function* initApp(action) {
  try {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      /*
       * TODO: Block for future features: AppConfig, Themes, Assets, Permissions, Translations...
       * - select primaryLanguage from me before/after request or from token/localStorage
       * - accessTokenDecodedPayload = jwt.decode(accessToken);
       * - { userId, userPrimaryLanguage } = accessTokenDecodedPayload;
       * - currentLanguage = primaryLanguage || i18next.getCurrentLanguage();
       * - await i18next.setCurrentLanguage(currentLanguage);
       * - fetch all[getMe, fetchTranslations, fetchPermissions...]
       */
      yield put(MeActionCreators.getMe[AsyncActionStatus.PENDING]());
      yield take([
        MeActionTypes.getMe[AsyncActionStatus.FULFILLED],
        MeActionTypes.getMe[AsyncActionStatus.REJECTED],
      ]);
    }
    yield put(AppActionCreators.initApp[AsyncActionStatus.FULFILLED]());
  } catch (error) {
    const errMessage = generateErrorMessage(error);
    yield put(AppActionCreators.initApp[AsyncActionStatus.REJECTED](errMessage));
    yield call(toast.error, errMessage);
  }
}

export default [
  takeEvery(
    AppActionTypes.initApp[AsyncActionStatus.PENDING],
    initApp,
  ),
];
